import IndexPagination from './IndexPagination';
export default IndexPagination;
